import { useEffect, useState } from "react";

export function useFormFields(initialState, callback) {
    const [fields, setValues] = useState(initialState);

    return [
        fields,
        function (event) {
            const newValues = {
                ...fields,
                [event.target.id || event.target.name]: event.target.value
            };
            setValues(newValues);
            if (callback && typeof callback === 'function') {
                callback(newValues);
            }
        },
        (replacement) => setValues(replacement)
    ];
}


// WEBPACK FOOTER //
// ./src/components/Shared/FormFields.js